import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  InputBase,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import DynamicTable from "../../../../Dynamic-table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import axios from "axios";
import dayjs from "dayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MedicineDoses, {
  MedicineDose,
} from "../../../../OPD/add-patient-record/MedicineDoses";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";

import CancelIcon from "@mui/icons-material/Cancel";
import Tooltip from "@mui/material/Tooltip";
import { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import FingerprintCaptureControls from "../../../../FingerprintCaptureControls";
import { useFingerprintCapture } from "../../../../../hooks/useFingerprintCapture";

interface OtAnaesthesiaMonitoring {
  patient_Identified: string;
  mrNoChecked: string;
  consentChecked: string;
  siteChecked: string;
  patient_Oriented: boolean;
}

function convertTime(inputTime: string): string {
  const date = new Date(inputTime);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (hours === 0) {
    hours = 12;
  }
  const minute = String(minutes).padStart(2, "0");
  return `${day}.${month}.${year}:${String(hours).padStart(
    2,
    "0"
  )}:${minute} ${ampm}`;
}

interface TemplateData {
  details: string;
}

interface Template {
  _id: string;
  templateName: string;
  templateData: TemplateData;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

interface maintenance_Of_Anesthesia {
  HR: string;
  cardiac_Rhythm: string;
  RR: string;
  BP: string;
  airway_Security_Patency: string;
  SpO2: string;
  level_Of_Anaesthesia: string;
  drugs_Misc: any;
  misc: any;
}

interface Vitals {
  Hr: string;
  Rr: string;
  Bp: string;
  spO2: string;
  temp: string;
}

interface FormData {
  advised_antibiotics: any;
  antibiotics: any;
  ot_anesthesia_monitoring: OtAnaesthesiaMonitoring;
  maintenance_Of_Anesthesia: maintenance_Of_Anesthesia;
  vitals: Vitals;
  anesthesia_Given: string;
  detail: string;
  sign_in: any;
  medicines: any;
  extra?: {
    consentForm?: {
      patientOrRelativeName: string;
      patientName: string;
      relationWithPatient: string;
      consentText: string;
      signature: string;
      doctorSignature: string;
      staffNameOrStamp: string;
      date: any;
      time: string;
    };
  };
}

interface OtRoomAnaesthesiaMonitoringProps {
  onChange: (data: any) => void;
  data: FormData;
  otherTabsData: any;
  profile: any;
}

const OtRoomAnaesthesiaMonitoring: React.FC<
  OtRoomAnaesthesiaMonitoringProps
> = ({ onChange, data, otherTabsData, profile }) => {
  const currentDate = dayjs();
  const [formdata, setFormdata] = useState<any>({
    sign_in: {
      patient_Confirmed: true,
      site_Marked: true,
      anaesthesia_Safety_Check: true,
      pulse_Oximeter: true,
      patient_Oriented: true,
      patient_Known_Allergy: "yes",
      difficulty_Risk: "yes",
      risk_Of_Blood_Loss: "yes",
      saved_At: null,
    },
    vitals: {
      HR: "",
      RR: "",
      BP: "",
      SPO2: "",
      temp: "",
    },
    anesthesia_Given: "",
    detail: "",
    maintenance_Of_Anesthesia: {
      cardiac_Rhythm: "Regular",
      airway_Security_Patency: "Patent",
      level_Of_Anaesthesia: "Deep",
      HR: "",
      RR: "",
      BP: "",
      SpO2: "",
      drugs_Misc: "",
      misc: "",
    },
    doctor_Name: "",
    date_Time: "",
    extra: {
      consentForm: {
        patientOrRelativeName: "",
        patientName: "",
        relationWithPatient: "",
        consentText: "",
        signature: "",
        doctorSignature: "",
        staffNameOrStamp: "",
        date: null,
        time: "",
      },
    },
  });

  const [medicineData, setMedicineData] = useState<MedicineDose[]>([]);
  const [anesthesiaRecords, setAnesthesiaRecords] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isMultiline, setIsMultiline] = useState(false);
  const [isMultilinetwo, setIsMultilinetwo] = useState(false);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [routeAdm, setRouteAdm] = useState<any>();
  const [addedMed, setAddedMed] = useState<any>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [givenMed, setGivenMed] = useState(false);
  const [advisedMed, setAdvisedMed] = useState(false);
  const [signColor, setSignColor] = useState<boolean>(false);
  const [dosageOptions, setDosageOptions] = useState<any[]>([]);
  const [antibiotics, setAntibiotics] = useState<any[]>([]);
  const [selectedDrug, setSelectedDrug] = useState<any>(null);
  const [selectedDosage, setSelectedDosage] = useState<any>(null);
  const [advisedData, setAdvisedData] = useState<any>();
  const [givenData, setGivenData] = useState<any>();
  const [hideAnti, setHideAnti] = useState<boolean>(false);
  const signatureRef = useRef<any>(null);
  const doctorSignatureRef = useRef<any>(null);
  const [signatureData, setSignatureData] = useState<string>("");
  const [doctorSignatureData, setDoctorSignatureData] = useState<string>("");
  const [isDateValid, setIsDateValid] = useState<boolean>(true); // Add validation state
  const [consentSubmitted, setConsentSubmitted] = useState(false);
  const [isEditingSignature, setIsEditingSignature] = useState(false);
  const [isEditingDoctorSignature, setIsEditingDoctorSignature] = useState(false);

  const handleFingerprintCaptured = useCallback((fingerprintDataUrl: string) => {
    signatureRef.current?.clear();
    setSignatureData(fingerprintDataUrl);
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra.consentForm,
          signature: fingerprintDataUrl,
        },
      },
    }));
  }, []);

  const handleDoctorFingerprintCaptured = useCallback(
    (fingerprintDataUrl: string) => {
      doctorSignatureRef.current?.clear();
      setDoctorSignatureData(fingerprintDataUrl);
      setFormdata((prev: any) => ({
        ...prev,
        extra: {
          ...prev.extra,
          consentForm: {
            ...prev.extra.consentForm,
            doctorSignature: fingerprintDataUrl,
          },
        },
      }));
    },
    []
  );

  const {
    fingerprintDevice,
    detectingDevice,
    capturingFingerprint,
    isFingerprintImage,
    setIsFingerprintImage,
    detectDevice,
    captureFingerprint,
    syncFingerprintFlag,
  } = useFingerprintCapture({ onCaptured: handleFingerprintCaptured });

  const {
    fingerprintDevice: doctorFingerprintDevice,
    detectingDevice: detectingDoctorDevice,
    capturingFingerprint: capturingDoctorFingerprint,
    isFingerprintImage: isDoctorFingerprintImage,
    setIsFingerprintImage: setIsDoctorFingerprintImage,
    detectDevice: detectDoctorDevice,
    captureFingerprint: captureDoctorFingerprint,
    syncFingerprintFlag: syncDoctorFingerprintFlag,
  } = useFingerprintCapture({ onCaptured: handleDoctorFingerprintCaptured });

  const handleSignatureEnd = () => {
    const signature = signatureRef.current?.toDataURL("image/png");
    setIsFingerprintImage(false);
    setSignatureData(signature);
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra.consentForm,
          signature: signature,
        },
      },
    }));
  };

  const clearSignature = () => {
    signatureRef.current?.clear();
    setSignatureData("");
    setIsFingerprintImage(false);
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra.consentForm,
          signature: "",
        },
      },
    }));
  };

  const enableSignatureEdit = () => {
    setIsEditingSignature(true);
    setIsFingerprintImage(false);
  };

  const enableDoctorSignatureEdit = () => {
    setIsEditingDoctorSignature(true);
    setIsDoctorFingerprintImage(false);
  };

  const handleDoctorSignatureEnd = () => {
    const signature = doctorSignatureRef.current?.toDataURL("image/png");
    setIsDoctorFingerprintImage(false);
    setDoctorSignatureData(signature);
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra.consentForm,
          doctorSignature: signature,
        },
      },
    }));
  };

  const clearDoctorSignature = () => {
    doctorSignatureRef.current?.clear();
    setDoctorSignatureData("");
    setIsDoctorFingerprintImage(false);
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra.consentForm,
          doctorSignature: "",
        },
      },
    }));
  };

  const getRouteAdm = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_OPD_API_URL}/routes-of-administration/getAllByPagination`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          count: 50000,
          pageNo: 1,
        },
      }
    );
    setRouteAdm(response.data?.data);
  };

  useEffect(() => {
    getRouteAdm();
  }, []);

  const getRouteNameById = (routAdministrationId: string) => {
    const route = routeAdm?.find(
      (item: any) => item?._id === routAdministrationId
    );
    return route ? route?.RA_Abbreviation : "";
  };

  const handleFocustwo = () => {
    setIsMultilinetwo(true);
  };

  const handleBlurtwo = () => {
    setIsMultilinetwo(false);
  };

  const handleFocus = () => {
    setIsMultiline(true);
  };

  const handleBlur = () => {
    setIsMultiline(false);
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_IPD_API_URL}/ipd-operation-template/getAllTemplates?ope_type=Anesthesia`,
          {
            headers: {
              accept: "*/*",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.data?.isSuccess) {
          setTemplates(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };
    fetchTemplates();
  }, []);

  const handleAnesthesiaPlanChange = (event: SelectChangeEvent<string>) => {
    const selectedTemplate = event.target.value;
    const selectedTemplateData = templates?.find(
      template => template.templateName === selectedTemplate
    );
    if (selectedTemplateData) {
      setFormdata((prevData: any) => ({
        ...prevData,
        anesthesia_Given: selectedTemplate,
        detail: selectedTemplateData.templateData.details || "",
      }));
    }
  };

  const handleSaveMaintenance = () => {
    const newRecord = {
      timestamp: new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }),
      ...formdata.maintenance_Of_Anesthesia,
    };
    if (editingIndex !== null) {
      setAnesthesiaRecords((prevRecords: any) =>
        prevRecords?.map((record: any, index: any) =>
          index === editingIndex ? newRecord : record
        )
      );
      setEditingIndex(null);
    } else {
      setAnesthesiaRecords((prevRecords: any) => [...prevRecords, newRecord]);
    }
    setFormdata((prev: any) => ({
      ...prev,
      maintenance_Of_Anesthesia: {
        cardiac_Rhythm: "Regular",
        airway_Security_Patency: "Patent",
        level_Of_Anaesthesia: "Deep",
        HR: "",
        RR: "",
        BP: "",
        SpO2: "",
        drugs_Misc: "",
        misc: "",
      },
    }));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name in formdata?.maintenance_Of_Anesthesia) {
      setFormdata((prev: any) => ({
        ...prev,
        maintenance_Of_Anesthesia: {
          ...prev?.maintenance_Of_Anesthesia,
          [name]: value,
        },
      }));
    } else if (name in formdata?.vitals) {
      setFormdata((prev: any) => ({
        ...prev,
        vitals: {
          ...prev.vitals,
          [name]: value,
        },
      }));
    }
  };

  const handleChangeVitals = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "HR") {
      if (newValue) {
        newValue = value;
      } else if (newValue > 250) {
        newValue = "250";
      }
    }
    if (name === "temp") {
      const numValue = parseFloat(value);
      newValue = !isNaN(numValue) ? Math.max(0, Math.min(107, numValue)) : "";
    } else if (name === "RR") {
      const numValue = parseInt(value, 10);
      newValue = !isNaN(numValue) ? Math.max(0, Math.min(80, numValue)) : "";
    } else if (name === "BP") {
      newValue = value;
    } else if (name === "SPO2") {
      const numValue = parseInt(value, 10);
      newValue = !isNaN(numValue) ? Math.max(0, Math.min(100, numValue)) : "";
    }
    setFormdata((prevFormdata: any) => ({
      ...prevFormdata,
      vitals: {
        ...prevFormdata.vitals,
        [name]: newValue,
      },
    }));
  };

  const handleSignInChange = (event: any) => {
    const { name, value, checked, type } = event.target;
    setFormdata((prevState: any) => ({
      ...prevState,
      sign_in: {
        ...prevState.sign_in,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  const handleSave = () => {
    const currentTime = new Date().toISOString();
    setFormdata((prevState: any) => ({
      ...prevState,
      sign_in: {
        ...prevState.sign_in,
        saved_At: dayjs(currentTime).format("DD.MM.YYYY hh:mm A"),
      },
    }));
    setSignColor(true);
    handleClose();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleConsentModalOpen = () => {
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra?.consentForm,
          date: prev.extra?.consentForm.date
            ? dayjs(prev?.extra?.consentForm?.date)
            : null,
        },
      },
    }));
    setConsentModalOpen(true);
    syncFingerprintFlag(formdata?.extra?.consentForm?.signature);
    syncDoctorFingerprintFlag(formdata?.extra?.consentForm?.doctorSignature);
    detectDevice(false);
    detectDoctorDevice(false);
  };

  const handleConsentModalClose = () => {
    setConsentModalOpen(false);
  };

  const handleConsentFormChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra?.consentForm,
          [name]: value,
        },
      },
    }));
  };

  const handleConsentFormSubmit = () => {
    setFormdata((prev: any) => ({
      ...prev,
      extra: {
        ...prev.extra,
        consentForm: {
          ...prev.extra?.consentForm,
          submitted: true, // <-- Add this flag
        },
      },
    }));
    setConsentSubmitted(true);
    setConsentModalOpen(false);
  };
  useEffect(() => {
    onChange({
      vitals: formdata?.vitals,
      anesthesia_Given: formdata?.anesthesia_Given,
      detail: formdata?.detail,
      maintenance_Of_Anesthesia: anesthesiaRecords,
      antibiotics: givenData,
      advised_antibiotics: advisedData,
      sign_in: formdata?.sign_in,
      doctor_Name: formdata?.doctor_Name,
      date_Time: formdata?.date_Time,
      extra: formdata?.extra,
    });
  }, [formdata, anesthesiaRecords, advisedData, givenData]);

  useEffect(() => {
    if (data) {
      setFormdata((prevData: any) => {
        const updatedData = { ...prevData, ...data };
        return updatedData;
      });
    }
    if (data?.maintenance_Of_Anesthesia) {
      setAnesthesiaRecords(data?.maintenance_Of_Anesthesia);
      setFormdata((prev: any) => ({
        ...prev,
        maintenance_Of_Anesthesia: {
          HR: "",
          cardiac_Rhythm: "",
          RR: "",
          BP: "",
          airway_Security_Patency: "",
          SpO2: "",
          level_Of_Anaesthesia: "",
          drugs_Misc: "",
          misc: "",
        },
      }));
    }
    if (data?.sign_in) {
      setSignColor(true);
    }
    if (data?.medicines) {
      setFormdata((prevData: any) => ({
        ...prevData,
        medicines: data?.medicines,
      }));
      setMedicineData(data?.medicines);
    }
    if (data?.advised_antibiotics) {
      setAdvisedData(data?.advised_antibiotics);
      setHideAnti(true);
    }
    if (
      data?.antibiotics &&
      data?.antibiotics?.dosage &&
      data?.antibiotics?.drugName
    ) {
      setGivenData(data?.antibiotics);
      setAdvisedMed(true);
      setHideAnti(true);
    }
    if (!data) {
      setFormdata((prevData: any) => ({
        ...prevData,
        doctor_Name: profile?.data?.fullName,
        date_Time: currentDate,
      }));
    }
  }, [data]);

  const handleDelete = (index: any) => {
    setAnesthesiaRecords((prevRecords: any) =>
      prevRecords?.filter((_: any, i: any) => i !== index)
    );
  };

  const handleEdit = (index: any) => {
    setEditingIndex(index);
    setFormdata((prev: any) => ({
      ...prev,
      maintenance_Of_Anesthesia: anesthesiaRecords[index],
    }));
  };

  const handleMedicineDoses = (medicineDoses: any[]) => {
    if (medicineDoses?.length > 0) {
      const latestMedicine: any = [medicineDoses[medicineDoses?.length - 1]];
      setAddedMed(latestMedicine);
      setMedicineData(latestMedicine);
    } else {
      setAddedMed([]);
      setMedicineData([]);
    }
  };

  const handleGivenOpen = () => {
    setGivenMed(true);
  };

  const handleGivenClick = () => {
    const antibioticData = {
      given_Time: currentDate,
      given_By: profile?.data?.fullName,
      drugName: advisedData?.drugName,
      dosage: advisedData?.dosage,
      route: advisedData?.route,
      frequency: advisedData?.frequency,
    };

    setGivenData(antibioticData);
    setGivenMed(false);
    setAdvisedMed(true);
  };

  const handleCancelClick = () => {
    setDialogOpen(false);
  };

  const handleAdvisedClick = (rowIndex: any) => {
    setDialogOpen(true);
  };

  const handleAdvised = () => {
    const antibioticData = {
      date_Time: currentDate,
      advised_By: profile?.data?.fullName,
      drugName: selectedDrug?.drugName,
      dosage: selectedDosage?.med_notation,
      route: "IV",
      frequency: "stat",
    };
    setAdvisedData(antibioticData);
    setDialogOpen(false);
    setHideAnti(true);
  };

  const getAllAntibiotics = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IPD_API_URL}/antibiotics-prophylaxis/getAllBySearch`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setAntibiotics(response?.data?.data);
    } catch (err) {
      console.error("Failed to fetch dosages", err);
    }
  };

  useEffect(() => {
    getAllAntibiotics();
  }, []);

  useEffect(() => {
    const getAllDosage = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_OPD_API_URL}/dosage/getAllBySearch`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setDosageOptions(response?.data?.data);
      } catch (err) {
        console.error("Failed to fetch dosages", err);
      }
    };
    getAllDosage();
  }, []);
  // ...existing code...

  useEffect(() => {
    if (
      consentModalOpen &&
      (!formdata?.extra?.consentForm?.date ||
        formdata?.extra?.consentForm?.date === null)
    ) {
      setFormdata((prev: any) => ({
        ...prev,
        extra: {
          ...prev.extra,
          consentForm: {
            ...prev.extra.consentForm,
            date: dayjs(),
            time: dayjs().format("hh:mm A"),
          },
        },
      }));
    }
  }, [consentModalOpen]);

  // ...existing code...
  useEffect(() => {
    if (formdata?.extra?.consentForm?.submitted) {
      setConsentSubmitted(true);
    }
  }, [formdata?.extra?.consentForm?.submitted]);

  const handleDrugChange = (value: any) => {
    setSelectedDosage(value?.allDosageNotations);
    setSelectedDrug(value);
  };

  return (
    <>
      <Box>
        <Grid container spacing={1}>
          <Grid item md={5.5} sm={12} xs={12}>
            <Box
              sx={{ bgcolor: "rgba(229, 229, 229, 1)", textAlign: "center" }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#3F3F3F",
                  fontWeight: "600",
                  py: 0.5,
                }}
              >
                Vitals
              </Typography>
            </Box>
            <Box sx={{ bgcolor: "rgba(245, 245, 245, 1)", p: 1 }}>
              <Grid container spacing={1}>
                <Grid item md={2.4} sm={4} xs={6}>
                  <TextField
                    label="Temp"
                    placeholder="92-107"
                    size="small"
                    className="search-field"
                    value={formdata?.vitals?.temp}
                    name="temp"
                    fullWidth
                    onChange={handleChangeVitals}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "10px" }}>F</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                <Grid item md={2.4} sm={4} xs={6}>
                  <TextField
                    label="RR"
                    placeholder="1-80"
                    size="small"
                    name="RR"
                    value={formdata?.vitals?.RR}
                    className="search-field"
                    fullWidth
                    onChange={handleChangeVitals}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "10px" }}>Min</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                <Grid item md={2.4} sm={4} xs={6}>
                  <TextField
                    label="HR"
                    placeholder="50-250"
                    size="small"
                    name="HR"
                    value={formdata?.vitals?.HR}
                    className="search-field"
                    fullWidth
                    onChange={e => {
                      const value = Number(e.target.value);
                      if (!isNaN(value) && value <= 250) {
                        handleChangeVitals(e);
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "10px" }}>/Min</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                <Grid item md={2.4} sm={4} xs={6}>
                  <TextField
                    label="BP"
                    placeholder="120/80"
                    size="small"
                    className="search-field"
                    value={formdata?.vitals?.BP}
                    name="BP"
                    // onChange={handleChangeVitals}
                    onChange={(e: any) => {
                      const value = e.target.value;
                      const regex = /^(\d{1,3})\/?(\d{0,3})$/;
                      if (value === "") {
                        handleChangeVitals(e);
                        return;
                      }
                      if (regex.test(value)) {
                        const parts = value.split("/");
                        const firstPart = parseInt(parts[0], 10);
                        const secondPart = parts[1]
                          ? parseInt(parts[1], 10)
                          : 0;

                        if (
                          firstPart >= 1 &&
                          firstPart <= 300 &&
                          secondPart <= firstPart
                        ) {
                          handleChangeVitals(e);
                        }
                      }
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "8px" }}>mgHg</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>

                <Grid item md={2.4} sm={4} xs={6}>
                  <TextField
                    label="SPO₂"
                    placeholder="SPO2"
                    name="SPO2"
                    size="small"
                    value={formdata?.vitals?.SPO2}
                    fullWidth
                    onChange={handleChangeVitals}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "10px" }}>%</span>
                        </InputAdornment>
                      ),
                    }}
                    className="search-field"
                  />
                </Grid>
              </Grid>
            </Box>
            <Grid container spacing={1}>
              <Grid item md={4} xs={6} sm={6}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#3F3F3F",
                    fontWeight: "600",
                    py: 0.5,
                  }}
                >
                  Anesthesia Given
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    name="anesthesia_Given"
                    value={formdata?.anesthesia_Given || "plan"}
                    onChange={handleAnesthesiaPlanChange}
                    sx={{
                      borderRadius: "12px",
                      border: "0px solid #D8D8D8",
                      background: "#F5F5FB",
                      fontSize: "12px",
                      height: "38px",
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                  >
                    <MenuItem value="plan">Select Anesthesia Plan</MenuItem>
                    {templates?.map(template => (
                      <MenuItem
                        key={template?._id}
                        value={template?.templateName}
                      >
                        {template?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={8} xs={6} sm={6}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#3F3F3F",
                    fontWeight: "600",
                    py: 0.5,
                  }}
                >
                  Details:
                </Typography>
                <TextField
                  size="small"
                  placeholder="Detail"
                  value={formdata?.detail}
                  onFocus={handleFocustwo}
                  onChange={e =>
                    setFormdata((prev: any) => ({
                      ...prev,
                      detail: e.target.value,
                    }))
                  }
                  onBlur={handleBlurtwo}
                  multiline={isMultilinetwo}
                  minRows={isMultilinetwo ? 3 : 1}
                  InputProps={{
                    style: {
                      borderRadius: "12px",
                      background: "#F5F5FB",
                      fontSize: "12px",
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      top: "-2px",
                    },
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6.5} sm={12} xs={12}>
            <Box
              sx={{ bgcolor: "rgba(229, 229, 229, 1)", textAlign: "center" }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#3F3F3F",
                  fontWeight: "600",
                  py: 0.5,
                }}
              >
                Maintenance of Anesthesia
              </Typography>
            </Box>
            <Box sx={{ bgcolor: "rgba(245, 245, 245, 1)", p: 1 }}>
              <Grid container spacing={1}>
                <Grid item md={2} sm={4} xs={6}>
                  <Box>
                    <TextField
                      required
                      placeholder="Drugs"
                      name="drugs_Misc"
                      fullWidth
                      label="Drugs"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none",
                          },
                          "&:hover fieldset": {
                            border: "none",
                          },
                          "&.Mui-focused fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          top: "-2px",
                        },
                        bgcolor: "white",
                      }}
                      value={formdata?.maintenance_Of_Anesthesia?.drugs_Misc} // Bind to state
                      onChange={handleChange} // Maintain existing handler
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      multiline={isMultiline}
                      minRows={isMultiline ? 3 : 1}
                      InputProps={{
                        style: {
                          borderRadius: "12px",
                          // background: "#F5F5FB",
                          fontSize: "12px",
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item md={2.5} sm={4} xs={6}>
                  <TextField
                    label="RR"
                    placeholder="1-80"
                    size="small"
                    name="RR"
                    value={formdata?.maintenance_Of_Anesthesia?.RR}
                    className="search-field"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        const numericValue = value ? Number(value) : null;
                        if (
                          numericValue === null ||
                          (numericValue >= 1 && numericValue <= 80)
                        ) {
                          setFormdata((prev: any) => ({
                            ...prev,
                            maintenance_Of_Anesthesia: {
                              ...prev.maintenance_Of_Anesthesia,
                              RR: value,
                            },
                          }));
                        }
                      }
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "12px" }}>ml</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      border:
                        formdata?.maintenance_Of_Anesthesia?.RR &&
                        (Number(formdata.maintenance_Of_Anesthesia.RR) < 1 ||
                          Number(formdata.maintenance_Of_Anesthesia.RR) > 80)
                          ? "1px solid red"
                          : "1px solid transparent",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                <Grid item md={2.5} sm={4} xs={6}>
                  <TextField
                    label="HR" // Label for the input
                    placeholder="50-250"
                    size="small"
                    sx={{ backgroundColor: "white" }}
                    className="search-field"
                    value={formdata?.maintenance_Of_Anesthesia?.HR}
                    name="HR"
                    onChange={(e: any) => {
                      const value = e.target.value;

                      if (/^\d*\.?\d*$/.test(value) || value === "") {
                        const numericValue = value ? Number(value) : null; // Convert to number if not empty
                        if (
                          numericValue === null ||
                          (numericValue >= 0 && numericValue <= 250)
                        ) {
                          handleChange(e); // Call the existing handler
                        }
                      }
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "12px" }}>/Min</span>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item md={2.5} sm={4} xs={6}>
                  <TextField
                    label="BP"
                    placeholder="120/80"
                    size="small"
                    className="search-field"
                    value={formdata?.maintenance_Of_Anesthesia?.BP}
                    // onChange={handleChange}
                    onChange={(e: any) => {
                      const value = e.target.value;
                      const regex = /^(\d{1,3})\/?(\d{0,3})$/;
                      if (value === "") {
                        handleChange(e);
                        return;
                      }
                      if (regex.test(value)) {
                        const parts = value.split("/");
                        const firstPart = parseInt(parts[0], 10);
                        const secondPart = parts[1]
                          ? parseInt(parts[1], 10)
                          : 0;
                        if (
                          firstPart >= 1 &&
                          firstPart <= 300 &&
                          secondPart <= firstPart
                        ) {
                          handleChange(e);
                        }
                      }
                    }}
                    name="BP"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <span style={{ fontSize: "12px" }}>mgHg</span>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
                <Grid item md={2.5} sm={4} xs={6}>
                  <Box
                    display="flex"
                    alignItems="center"
                    className="search-field"
                    bgcolor={"white"}
                  >
                    <TextField
                      label="SPO₂"
                      placeholder="SPO2"
                      name="SpO2"
                      size="small"
                      value={formdata?.maintenance_Of_Anesthesia?.SpO2}
                      onChange={(e: any) => {
                        const value = e.target.value;
                        if (
                          /^\d*\.?\d*$/.test(value) &&
                          (value === "" || parseFloat(value) <= 100)
                        ) {
                          handleChange(e);
                        }
                      }}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root": {
                          fontSize: "12px",
                          borderRadius: "12px",
                          backgroundColor: "white",
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        padding: "10px",
                        ml: 1,
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                    >
                      %
                    </Typography>
                  </Box>
                </Grid>
                <Grid item md={4} sm={4} xs={6}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#3F3F3F",
                      fontWeight: "600",
                    }}
                  >
                    Airway Security Patency :{" "}
                  </Typography>
                  <RadioGroup
                    name="airway_Security_Patency"
                    row
                    value={
                      formdata?.maintenance_Of_Anesthesia
                        ?.airway_Security_Patency
                    }
                    onChange={handleChange}
                    sx={{ alignItems: "center" }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        value="Patent"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={<span style={{ fontSize: "10px" }}>Patent</span>}
                      />
                      <FormControlLabel
                        value="NotPatent"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={
                          <span style={{ fontSize: "10px" }}> Not Patent </span>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </Grid>
                <Grid item md={4} sm={4} xs={6}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#3F3F3F",
                      fontWeight: "600",
                    }}
                  >
                    Cardiac Rhythm :
                  </Typography>
                  <RadioGroup
                    name="cardiac_Rhythm"
                    row
                    value={formdata?.maintenance_Of_Anesthesia?.cardiac_Rhythm}
                    onChange={handleChange}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        value="Regular"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={
                          <span style={{ fontSize: "10px" }}>Regular</span>
                        }
                      />
                      <FormControlLabel
                        value="Irregular"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={
                          <span style={{ fontSize: "10px" }}>Irregular</span>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </Grid>
                <Grid item md={4} sm={4} xs={6}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      color: "#3F3F3F",
                      fontWeight: "600",
                    }}
                  >
                    Level of Anaesthesia :{" "}
                  </Typography>
                  <RadioGroup
                    name="level_Of_Anaesthesia"
                    row
                    value={
                      formdata.maintenance_Of_Anesthesia.level_Of_Anaesthesia
                    }
                    onChange={handleChange}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormControlLabel
                        value="Deep"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={<span style={{ fontSize: "10px" }}>Deep</span>}
                      />
                      <FormControlLabel
                        value="superficial"
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                height: 15,
                                width: 15,
                              },
                            }}
                          />
                        }
                        label={
                          <span style={{ fontSize: "10px" }}>SuperFicial</span>
                        }
                      />
                    </Box>
                  </RadioGroup>
                </Grid>
                <Grid item md={2.5} sm={4} xs={6}>
                  <Typography sx={{ fontSize: "10px", fontWeight: "600" }}>
                    MISC{" "}
                    <span style={{ fontSize: "8px", color: "#ddd" }}>
                      (Optional)
                    </span>
                  </Typography>
                  <TextField
                    required
                    placeholder="Misc"
                    name="misc"
                    fullWidth
                    className="search-field"
                    size="small"
                    value={formdata.maintenance_Of_Anesthesia.misc}
                    onChange={handleChange}
                    sx={{
                      border: "1px solid rgba(229, 229, 229, 1)",
                      bgcolor: "white",
                    }}
                  />
                </Grid>

                <Grid item md={1} sx={{ mt: 2.5 }}>
                  <Button
                    disabled={
                      !formdata?.maintenance_Of_Anesthesia?.SpO2 ||
                      !formdata?.maintenance_Of_Anesthesia?.BP ||
                      !formdata?.maintenance_Of_Anesthesia?.RR ||
                      !formdata?.maintenance_Of_Anesthesia?.HR ||
                      !formdata?.maintenance_Of_Anesthesia?.drugs_Misc
                    }
                    size="small"
                    onClick={handleSaveMaintenance}
                    variant="contained"
                  >
                    Save
                  </Button>
                </Grid>
                <Grid item md={3} sx={{ mt: 2.5, ml: 3 }}>
                  <Button
                    size="small"
                    onClick={handleConsentModalOpen}
                    variant="contained"
                  >
                    Consent Form
                  </Button>
                </Grid>
                <Grid
                  item
                  md={2}
                  sm={2}
                  xs={1}
                  sx={{
                    mt: 2.5,
                    ml: "auto",
                    // mr: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      // height: "36px",
                      // width: "140px",
                      fontSize: "11px",
                      // background: formdata?.sign_in &&
                      //     Object.values(formdata.sign_in).some(
                      //         (value) => value === true || value === "yes" || value === "no"
                      //     )
                      //     ? "#009E65"
                      //     : "#FFBF00",
                      background: signColor ? "#009E65" : "#FFBF00",
                      color: "#FFF",
                      borderRadius: "8px",
                      "&:hover": {
                        background:
                          formdata?.sign_in &&
                          Object.values(formdata.sign_in).some(
                            value =>
                              value === true ||
                              value === "yes" ||
                              value === "no"
                          )
                            ? "#007A4D"
                            : "#E6A800",
                      },
                    }}
                    onClick={handleOpen}
                  >
                    Sign In
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Grid item md={12} sm={12} xs={12}>
            <DynamicTable
              headers={[
                "SN",
                "Date & Time",
                "HR",
                "BP",
                "RR",
                "SpO2",
                "Cardiac Rhythm",
                "Airway Sec.Pt",
                "Lvl of Anesthesia",
                "Drugs",
                "Misc",
                "Action",
              ]}
              data={anesthesiaRecords?.map((item: any, index: number) => [
                index + 1,
                convertTime(item?.timestamp),
                item?.HR,
                item?.BP,
                item?.RR,
                item?.SpO2,
                item?.cardiac_Rhythm,
                item?.airway_Security_Patency,
                item?.level_Of_Anaesthesia,
                item?.drugs_Misc,
                item?.misc,
              ])}
              actionButtons={[
                {
                  icon: (
                    <EditIcon
                      sx={{
                        color: "#FFB800",
                        minWidth: "20.09px",
                        minHeight: "20.09px",
                        height: 20.09,
                        width: 29.09,
                        "&:hover": {
                          background: "none",
                          color: "rgb(133, 96, 1)",
                        },
                      }}
                    />
                  ),
                  onClick: (rowIndex: number) => handleEdit(rowIndex),
                },
                {
                  icon: (
                    <DeleteIcon
                      sx={{
                        color: "#FF5454",
                        minWidth: "20.09px",
                        minHeight: "20.09px",
                        height: 20.09,
                        width: 29.09,
                        "&:hover": {
                          background: "none",
                          color: "rgb(191, 44, 44)",
                        },
                      }}
                    />
                  ),
                  onClick: (rowIndex: number) => handleDelete(rowIndex),
                },
              ]}
            />
          </Grid>
        </Grid>
        <Box sx={{ background: "#ddd", mb: 0.5, mt: 1 }}>
          <Typography
            sx={{ fontSize: "12px", fontWeight: "600", textAlign: "center" }}
          >
            Anitbiotic Prophylax:
          </Typography>
        </Box>
        {!hideAnti && (
          <Grid container spacing={1} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={3.5} md={3}>
              <Autocomplete
                value={selectedDrug}
                onChange={(event, newValue) => handleDrugChange(newValue)}
                options={antibiotics || []}
                getOptionLabel={option => option?.drugName || ""}
                size="small"
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select Drug"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="search-field"
                  />
                )}
                disableClearable
              />
            </Grid>
            <Grid item xs={12} sm={3.5} md={3}>
              <Autocomplete
                value={selectedDosage}
                onChange={(event, newValue) => setSelectedDosage(newValue)}
                options={dosageOptions || []}
                getOptionLabel={option => option?.med_notation || ""}
                size="small"
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Select Dosage"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="search-field"
                  />
                )}
                disableClearable
              />
            </Grid>
            <Grid item xs={6} sm={1.5} md={1.5}>
              <TextField
                label="Route"
                value={"IV"}
                className="search-field"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={1.5} md={1.5}>
              <TextField
                label="Frequency"
                value={"stat"}
                className="search-field"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item md={2} sm={2} xs={12}>
              <Button
                size="small"
                onClick={handleAdvisedClick}
                variant="contained"
                disabled={!selectedDrug || !selectedDosage}
                sx={{ mt: 0.5 }}
              >
                Advised
              </Button>
            </Grid>
          </Grid>
        )}

        {(advisedData || givenData) && (
          <Box display="flex" alignItems="center" gap={2}>
            <Typography sx={{ fontSize: "12px" }}>
              {" "}
              {givenData?.drugName
                ? givenData?.drugName
                : advisedData?.drugName}{" "}
              , {givenData?.dosage ? givenData?.dosage : advisedData?.dosage}{" "}
              <span style={{ fontWeight: "bold" }}> x </span>{" "}
              {givenData?.route ? givenData?.route : advisedData?.route}{" "}
              <span style={{ fontWeight: "bold" }}> x </span>{" "}
              {givenData?.frequency
                ? givenData?.frequency
                : advisedData?.frequency}
              , <span style={{ fontWeight: "bold" }}>Advised By : </span>{" "}
              {advisedData?.advised_By},{" "}
              {dayjs(advisedData?.given_Time).format("DD.MM.YYYY hh:mm A")},{" "}
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {givenData?.given_By ? "Given By" : ""} :{" "}
              </span>{" "}
              {givenData?.given_By} ,{" "}
              {givenData?.date_Time
                ? dayjs(givenData?.date_Time).format("DD.MM.YYYY hh:mm A")
                : ""}{" "}
            </Typography>
            <Button
              size="small"
              onClick={handleGivenOpen}
              variant="contained"
              sx={{ mt: 0.5 }}
              disabled={advisedMed}
            >
              Given Antibiotic
            </Button>
          </Box>
        )}

        <Dialog open={isOpen}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle>Anesthesia Plan</DialogTitle>
            <CancelOutlinedIcon
              sx={{ cursor: "pointer", mr: 2 }}
              onClick={handleClose}
            />
          </Box>
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  border: "1px solid #000",
                  height: "100%",
                  width: "100%",
                  p: 2,
                }}
              >
                <Box
                  sx={{ backgroundColor: "#000", color: "#fff", p: 1, mb: 2 }}
                >
                  <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
                    SIGN IN
                  </Typography>
                </Box>
                <FormGroup sx={{ display: "flex", flexDirection: "column" }}>
                  {/* PATIENT HAS CONFIRMED */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "row",
                      gap: 0.5,
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="patient_Confirmed"
                          checked={formdata.sign_in.patient_Confirmed}
                          onChange={handleSignInChange}
                          size="small"
                        />
                      }
                      label={""}
                    />
                    <Typography variant="body2">
                      Patient has confirmed:
                      <ul style={{ margin: 0, paddingLeft: "20px" }}>
                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                          Name : {otherTabsData?.patientData?.patientName}
                        </li>
                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                          MRN : {otherTabsData?.patientData?.mrn}
                        </li>
                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />
                          Identity
                        </li>
                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />{" "}
                          Site
                        </li>

                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />{" "}
                          Procedure
                        </li>

                        <li>
                          <FiberManualRecordIcon sx={{ fontSize: "11px" }} />{" "}
                          Consent
                        </li>
                      </ul>
                    </Typography>
                  </Box>
                  <Divider />

                  {/* SITE MARKED */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="site_Marked"
                        checked={formdata.sign_in.site_Marked}
                        onChange={handleSignInChange}
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Site Marked/Not Applicable
                      </Typography>
                    }
                  />
                  <Divider />

                  {/* ANAESTHESIA SAFETY CHECK */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="anaesthesia_Safety_Check"
                        checked={formdata.sign_in.anaesthesia_Safety_Check}
                        onChange={handleSignInChange}
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Anaesthesia Safety Check Completed
                      </Typography>
                    }
                  />
                  <Divider />

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="pulse_Oximeter"
                        checked={formdata.sign_in.pulse_Oximeter}
                        onChange={handleSignInChange}
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Pulse Oximeter on Patient and Functioning
                      </Typography>
                    }
                  />
                  {/* <FormControlLabel
                                        control={<Checkbox name="patient_Oriented" checked={formdata.sign_in.patient_Oriented} onChange={handleSignInChange} size="small" />}
                                        label={<Typography variant="body2">Patient Oriented?</Typography>}
                                    /> */}
                  <Divider />
                  <Typography variant="body2">
                    Is the Patient Oriented?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="patient_Oriented"
                        checked={formdata.sign_in.patient_Oriented === true}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              patient_Oriented: true,
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">Yes</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="patient_Oriented"
                        checked={formdata.sign_in.patient_Oriented === false}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              patient_Oriented: false,
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">No</Typography>}
                  />

                  <Typography variant="body2">
                    Does Patient Have a Known Allergy?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="patient_Known_Allergy"
                        checked={
                          formdata.sign_in.patient_Known_Allergy === "yes"
                        }
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              patient_Known_Allergy: "yes",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">Yes</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="patient_Known_Allergy"
                        checked={
                          formdata.sign_in.patient_Known_Allergy === "no"
                        }
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              patient_Known_Allergy: "no",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">No</Typography>}
                  />
                  {/* DIFFICULT AIRWAY */}
                  <Typography variant="body2">
                    Difficult Airway/Aspiration Risk?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="difficulty_Risk"
                        checked={formdata.sign_in.difficulty_Risk === "yes"}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              difficulty_Risk: "yes",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Yes, and Equipment/Assistance Available
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="difficulty_Risk"
                        checked={formdata.sign_in.difficulty_Risk === "no"}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              difficulty_Risk: "no",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">No</Typography>}
                  />
                  {/* RISK OF BLOOD LOSS */}
                  <Typography variant="body2">
                    Risk of 500ML Blood Loss (7ML/KG in Children)?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="risk_Of_Blood_Loss"
                        checked={formdata.sign_in.risk_Of_Blood_Loss === "yes"}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              risk_Of_Blood_Loss: "yes",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        Yes, and Adequate Intravenous Access and Fluids Planned
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="risk_Of_Blood_Loss"
                        checked={formdata.sign_in.risk_Of_Blood_Loss === "no"}
                        onChange={() =>
                          setFormdata({
                            ...formdata,
                            sign_in: {
                              ...formdata.sign_in,
                              risk_Of_Blood_Loss: "no",
                            },
                          })
                        }
                        size="small"
                      />
                    }
                    label={<Typography variant="body2">No</Typography>}
                  />
                </FormGroup>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSave} variant="contained">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={consentModalOpen} onClose={handleConsentModalClose}>
          <DialogTitle>
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              className="urduNotationFont"
              sx={{ fontWeight: "bold", direction: "rtl" }}
            >
              اجازت نامہ برائے اینستھیزیا
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ p: 2 }}>
              <Typography
                variant="body2"
                align="right"
                paragraph
                className="urduNotationFont"
                sx={{
                  fontSize: "12px",
                  textAlign: "justify",
                  direction: "rtl",
                }}
              >
                میرا / میری نام{" "}
                <TextField
                  name="patientOrRelativeName"
                  value={formdata?.extra?.consentForm?.patientOrRelativeName}
                  onChange={handleConsentFormChange}
                  size="small"
                  variant="standard"
                  sx={{
                    width: "150px",
                    display: "inline-flex",
                    verticalAlign: "middle",
                    "& .MuiInputBase-input": {
                      textAlign: "left",
                      fontSize: "12px",
                    },
                  }}
                  inputProps={{
                    style: { direction: "ltr" },
                  }}
                />{" "}
                ہے۔ میں اس ہسپتال کے ڈاکٹرز کو اجازت دیتا / دیتی ہوں کہ وہ میرے
                یا میرے مریض{" "}
                <TextField
                  name="patientName"
                  value={formdata?.extra?.consentForm?.patientName}
                  onChange={handleConsentFormChange}
                  size="small"
                  variant="standard"
                  sx={{
                    width: "150px",
                    display: "inline-flex",
                    verticalAlign: "middle",
                    "& .MuiInputBase-input": {
                      textAlign: "left",
                      fontSize: "12px",
                    },
                  }}
                  inputProps={{
                    style: { direction: "ltr" },
                  }}
                />{" "}
                کے لئے ضروری اینستھیزیا دیں۔ میں سمجھتا / سمجھتی ہوں کہ
                اینستھیزیا کے دوران کچھ خطرات ہو سکتے ہیں جن میں{" "}
                <TextField
                  name="consentText"
                  value={formdata?.extra?.consentForm?.consentText}
                  onChange={handleConsentFormChange}
                  size="small"
                  variant="standard"
                  sx={{
                    width: "200px",
                    display: "inline-flex",
                    verticalAlign: "middle",
                    "& .MuiInputBase-input": {
                      textAlign: "left",
                      fontSize: "12px",
                    },
                  }}
                  inputProps={{
                    style: { direction: "ltr" },
                  }}
                />{" "}
                شامل ہیں۔ لیکن میں ان خطرات کو سمجھ کر اینستھیزیا کی اجازت دیتا
                / دیتی ہوں۔ یہ اجازت نامہ میری مرضی سے دیا گیا ہے۔
              </Typography>
              <Typography
                variant="body2"
                align="left"
                paragraph
                className="urduNotationFont"
                sx={{
                  fontSize: "12px",
                  textAlign: "justify",
                  direction: "rtl",
                }}
              >
                میرا مریض کے ساتھ تعلق{" "}
                <TextField
                  name="relationWithPatient"
                  value={formdata?.extra?.consentForm?.relationWithPatient}
                  onChange={handleConsentFormChange}
                  size="small"
                  variant="standard"
                  sx={{
                    width: "150px",
                    display: "inline-flex",
                    verticalAlign: "middle",
                    "& .MuiInputBase-input": {
                      textAlign: "left",
                      fontSize: "12px",
                    },
                  }}
                  inputProps={{
                    style: { direction: "ltr" },
                  }}
                />{" "}
                ہے۔
              </Typography>
              <Box
                component="form"
                onSubmit={e => {
                  e.preventDefault();
                  handleConsentFormSubmit();
                }}
              >
                <Grid container spacing={2}>
                  {/* Left Side: Signature Field */}
                  <Grid item xs={12} sm={6}>
                    <Box display="flex" flexDirection="column" gap={1} dir="ltr">
                      <Box display="flex" alignItems="center" gap={1} dir="rtl">
                        <Typography
                          className="urduNotationFont"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                            minWidth: "90px",
                          }}
                        >
                          دستخط:
                        </Typography>
                      </Box>
                      {!(
                        consentSubmitted &&
                        formdata?.extra?.consentForm?.signature &&
                        !isEditingSignature
                      ) && (
                        <FingerprintCaptureControls
                          fingerprintDevice={fingerprintDevice}
                          detectingDevice={detectingDevice}
                          capturingFingerprint={capturingFingerprint}
                          onDetect={() => detectDevice(true)}
                          onCapture={captureFingerprint}
                        />
                      )}
                      <Box
                        dir="ltr"
                        sx={{
                          position: "relative",
                          border: "1px solid #000",
                          borderRadius: "4px",
                          padding: "0px",
                          width: "250px",
                          height: "180px",
                          overflow: "hidden",
                          background:
                            consentSubmitted &&
                            formdata?.extra?.consentForm?.signature
                              ? "#f5f5f5"
                              : "transparent",
                        }}
                      >
                        {(consentSubmitted &&
                          formdata?.extra?.consentForm?.signature &&
                          !isEditingSignature) ||
                        (isFingerprintImage &&
                          formdata?.extra?.consentForm?.signature &&
                          !isEditingSignature) ? (
                          <>
                            <img
                              src={formdata?.extra?.consentForm?.signature}
                              alt={
                                isFingerprintImage ? "Fingerprint" : "Signature"
                              }
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                pointerEvents: "none",
                                background: "#fff",
                              }}
                            />
                            {consentSubmitted ? (
                              <Button
                                onClick={enableSignatureEdit}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  minWidth: "auto",
                                  padding: "4px 8px",
                                  fontSize: "10px",
                                  backgroundColor: "rgba(25, 118, 210, 0.9)",
                                  color: "#fff",
                                  "&:hover": {
                                    backgroundColor: "rgba(25, 118, 210, 1)",
                                  },
                                }}
                              >
                                <EditIcon sx={{ fontSize: "14px", mr: 0.5 }} />
                                Edit
                              </Button>
                            ) : (
                              <Button
                                onClick={clearSignature}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  minWidth: "24px",
                                  padding: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                  },
                                }}
                              >
                                <CancelIcon
                                  sx={{ color: "#ff0000", fontSize: "20px" }}
                                />
                              </Button>
                            )}
                          </>
                        ) : (
                          <>
                            <SignatureCanvas
                              ref={signatureRef}
                              penColor="black"
                              backgroundColor="transparent"
                              onEnd={handleSignatureEnd}
                              dotSize={1}
                              minWidth={0.5}
                              maxWidth={1.5}
                              canvasProps={{
                                width: 250,
                                height: 180,
                                style: {
                                  cursor: "crosshair",
                                  display: "block",
                                  touchAction: "none",
                                  width: "100%",
                                  height: "100%",
                                },
                              }}
                            />
                            <Button
                              onClick={clearSignature}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                minWidth: "24px",
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                            >
                              <CancelIcon
                                sx={{ color: "#ff0000", fontSize: "20px" }}
                              />
                            </Button>
                          </>
                        )}
                      </Box>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap={1}
                      dir="ltr"
                      sx={{ mt: 2 }}
                    >
                      <Typography
                        className="urduNotationFont"
                        sx={{
                          fontSize: "12px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          minWidth: "90px",
                          direction: "rtl",
                        }}
                      >
                        ڈاکٹر کے دستخط :
                      </Typography>
                      {!(
                        consentSubmitted &&
                        formdata?.extra?.consentForm?.doctorSignature &&
                        !isEditingDoctorSignature
                      ) && (
                        <FingerprintCaptureControls
                          fingerprintDevice={doctorFingerprintDevice}
                          detectingDevice={detectingDoctorDevice}
                          capturingFingerprint={capturingDoctorFingerprint}
                          onDetect={() => detectDoctorDevice(true)}
                          onCapture={captureDoctorFingerprint}
                        />
                      )}
                      <Box
                        dir="ltr"
                        sx={{
                          position: "relative",
                          border: "1px solid #000",
                          borderRadius: "4px",
                          padding: "0px",
                          width: "250px",
                          height: "180px",
                          overflow: "hidden",
                          background:
                            consentSubmitted &&
                            formdata?.extra?.consentForm?.doctorSignature
                              ? "#f5f5f5"
                              : "transparent",
                        }}
                      >
                        {(consentSubmitted &&
                          formdata?.extra?.consentForm?.doctorSignature &&
                          !isEditingDoctorSignature) ||
                        (isDoctorFingerprintImage &&
                          formdata?.extra?.consentForm?.doctorSignature &&
                          !isEditingDoctorSignature) ? (
                          <>
                            <img
                              src={formdata?.extra?.consentForm?.doctorSignature}
                              alt={
                                isDoctorFingerprintImage
                                  ? "Doctor Fingerprint"
                                  : "Doctor Signature"
                              }
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                pointerEvents: "none",
                                background: "#fff",
                              }}
                            />
                            {consentSubmitted ? (
                              <Button
                                onClick={enableDoctorSignatureEdit}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  minWidth: "auto",
                                  padding: "4px 8px",
                                  fontSize: "10px",
                                  backgroundColor: "rgba(25, 118, 210, 0.9)",
                                  color: "#fff",
                                  "&:hover": {
                                    backgroundColor: "rgba(25, 118, 210, 1)",
                                  },
                                }}
                              >
                                <EditIcon sx={{ fontSize: "14px", mr: 0.5 }} />
                                Edit
                              </Button>
                            ) : (
                              <Button
                                onClick={clearDoctorSignature}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  minWidth: "24px",
                                  padding: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                  },
                                }}
                              >
                                <CancelIcon
                                  sx={{ color: "#ff0000", fontSize: "20px" }}
                                />
                              </Button>
                            )}
                          </>
                        ) : (
                          <>
                            <SignatureCanvas
                              ref={doctorSignatureRef}
                              penColor="black"
                              backgroundColor="transparent"
                              onEnd={handleDoctorSignatureEnd}
                              dotSize={1}
                              minWidth={0.5}
                              maxWidth={1.5}
                              canvasProps={{
                                width: 250,
                                height: 180,
                                style: {
                                  cursor: "crosshair",
                                  display: "block",
                                  touchAction: "none",
                                  width: "100%",
                                  height: "100%",
                                },
                              }}
                            />
                            <Button
                              onClick={clearDoctorSignature}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                minWidth: "24px",
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                            >
                              <CancelIcon
                                sx={{ color: "#ff0000", fontSize: "20px" }}
                              />
                            </Button>
                          </>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                  {/* Right Side: Staff Name, Date & Time, Doctor Name */}
                  <Grid item xs={12} sm={6}>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {/* Staff Name */}
                      <Box display="flex" alignItems="center" gap={1} dir="rtl">
                        <Typography
                          className="urduNotationFont"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          اسٹاف کا نام:
                        </Typography>
                        <TextField
                          name="staffNameOrStamp"
                          value={formdata?.extra?.consentForm?.staffNameOrStamp}
                          onChange={handleConsentFormChange}
                          size="small"
                          variant="standard"
                          sx={{
                            flex: 1,
                            "& .MuiInput GenBase-input": {
                              textAlign: "left",
                            },
                          }}
                          inputProps={{
                            style: { direction: "ltr" },
                            //readOnly: !!formdata?.extra?.consentForm?.signature, // Disable if signed
                          }}
                        />
                      </Box>
                      {/* Date & Time */}
                      <Box display="flex" alignItems="center" gap={1} dir="rtl">
                        <Typography
                          className="urduNotationFont"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          تاریخ و وقت:
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={formdata?.extra?.consentForm?.date || null}
                            onChange={newValue => {
                              setFormdata((prev: any) => ({
                                ...prev,
                                extra: {
                                  ...prev.extra,
                                  consentForm: {
                                    ...prev?.extra?.consentForm,
                                    date: newValue ? dayjs(newValue) : null,
                                    time: newValue
                                      ? dayjs(newValue).format("hh:mm A")
                                      : "",
                                  },
                                },
                              }));
                              setIsDateValid(!!newValue);
                            }}
                            format="DD.MM.YYYY hh:mm A"
                            //disabled={!!formdata?.extra?.consentForm?.signature} // Disable if signed
                            slotProps={{
                              textField: {
                                variant: "standard",
                                size: "small",
                                placeholder: "Select Date and Time",
                                sx: {
                                  flex: 1,
                                  "& .MuiInputBase-root": {
                                    fontSize: "12px",
                                  },
                                  "& .MuiInputAdornment-root": {
                                    marginRight: "8px",
                                  },
                                },
                                inputProps: {
                                  style: { direction: "ltr" },
                                  readOnly:
                                    !!formdata?.extra?.consentForm?.signature, // Disable typing if signed
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                      {/* Spacer to align with doctor signature */}
                      <Box sx={{ height: "16px" }} />
                      {/* Doctor Name - aligned with doctor signature */}
                      <Box display="flex" alignItems="center" gap={1} dir="rtl">
                        <Typography
                          className="urduNotationFont"
                          sx={{
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ڈاکٹر کا نام:
                        </Typography>
                        <TextField
                          name="doctorName"
                          value={formdata?.extra?.consentForm?.doctorName}
                          onChange={handleConsentFormChange}
                          size="small"
                          variant="standard"
                          sx={{
                            flex: 1,
                            "& .MuiInputBase-input": {
                              textAlign: "left",
                            },
                          }}
                          inputProps={{
                            style: { direction: "ltr" },
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 3,
                    gap: 2,
                  }}
                >
                  <Button variant="outlined" onClick={handleConsentModalClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    disabled={
                      !formdata?.extra?.consentForm?.date || !isDateValid
                    }
                    color="primary"
                    type="submit"
                  >
                    Submit Consent
                  </Button>
                </Box>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
      <Box mt={2}>
        <Grid container spacing={1}>
          <Grid item md={2.4} sm={6} xs={12}>
            <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
              Doctor Name
            </Typography>
            <TextField
              value={formdata?.doctor_Name}
              disabled
              fullWidth
              className="search-field"
              size="small"
            />
          </Grid>
          <Grid item md={2.4} sm={6} xs={12}>
            <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
              Date&Time{" "}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                value={dayjs(formdata?.date_Time)}
                disabled={true}
                format="DD.MM.YYYY hh:mm A"
                sx={{
                  "& fieldset": { border: "none" },
                  "& .MuiInputBase-root": {
                    height: "38px",
                    fontSize: "12px",
                    overflow: "hidden",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor: "#F5F5FB",
                  },
                  width: "100%",
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>
      <Dialog open={dialogOpen} onClose={handleCancelClick}>
        <DialogContent>
          Are you sure you want to Advised this Medicine?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClick} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAdvised} color="primary">
            Advised
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={givenMed} onClose={() => setGivenMed(false)}>
        <DialogContent>
          Are you sure you want to mark this Medicine as given?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setGivenMed(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleGivenClick} color="primary">
            Given
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OtRoomAnaesthesiaMonitoring;
